import { COLLAR_payoffInfo } from "src/shared/Cotation/describe/Collar"
import { COLLAR_default } from "./default/Collar"
import { checkExistValuesForm } from "src/shared/utils/helpers"
import { axisConfig } from "./config/AxisConfig"
import { CHART_STYLES } from "./config/ChartStyles"
import { ProdcutType } from "src/type/product"

const styles = CHART_STYLES[ProdcutType.COLLAR]

const defaultConfig = axisConfig("Taux d'intérêt", "Taux de couverture", true, true) 

const  COLLAR_chart = form => ([
    {
        type: "line",
        key: "price-1",           
        data: [
            {x: form.strike_floor >=0 ? -1 : form.strike_floor*2, y: form.strike_floor}, 
            {x: form.strike_floor - form.prime_de_couverture/100, y: form.strike_floor}
        ],            
        color: styles.couverture.color, 
        strokeWidth: styles.couverture.strokeWidth
    },
    {
        type: "line",
        key: "price-2",     
        data: [
            {x: form.strike_floor - form.prime_de_couverture/100, y: form.strike_floor}, 
            {x: form.strike_cap - form.prime_de_couverture/100, y: form.strike_cap}
        ],                
        color: styles.couverture.color, 
        strokeWidth: styles.couverture.strokeWidth
    },
    {
        type: "line",
        key: "price-3",            
        data: [
            {x: form.strike_cap - form.prime_de_couverture/100, y: form.strike_cap}, 
            {x: Math.abs(form.strike_cap*2), y: form.strike_cap}
        ],     
        color: styles.couverture.color, 
        strokeWidth: styles.couverture.strokeWidth
    },
    {
        type: "line",
        key: "sous-jacent",            
        data: [
            {x: form.strike_floor >=0 ? -1 : form.strike_floor*2, y: form.strike_floor >=0 ? -1 : form.strike_floor*2}, 
            {x: Math.abs(form.strike_cap*2), y: Math.abs(form.strike_cap*2)}
        ], 
        color: styles.indice_sous_jacent.color,
    },
    {
        type: "point",
        key : "strike-cap-dot-y",
        data: [
            {x: 0, y: form.strike_cap}
        ],
        color: styles.strike_cap.color,
        caption: `Strike cap : ${form.strike_cap}`
    },
    {
        type: "point",
        key : "strike-floor-dot-y",
        data: [
            {x: 0, y: form.strike_floor}
        ],
        color: styles.strike_floor.color,
        caption: `Strike floor : ${form.strike_floor}`
    }
])

export const COLLAR_data = (form) => ([
    {
        option: "1",
        label: 'Profil de couverture à chaque date de constatation du fixing',
        chart: COLLAR_chart(form),
        chartDefault: COLLAR_chart(COLLAR_default[0]),
        describe: COLLAR_payoffInfo(form),
        legends: {
            lines: [
                {title: "Couverture",           color: styles.couverture.color,          strokeWidth: styles.couverture.strokeWidth},
                {title: "Indice sous-jacent",   color: styles.indice_sous_jacent.color,  strokeWidth: styles.indice_sous_jacent.strokeWidth}
            ],
            points: [
                {title: "Strike floor",         color: styles.strike_floor.color},
                {title: "Strike cap",           color: styles.strike_cap.color},
            ]
        },
        config: defaultConfig,
        condition: checkExistValuesForm(form, []),
        isAvailable: true
    }
])




// WEBPACK FOOTER //
// ./src/shared/Cotation/chart/data/Collar.tsx